import { EWorldMapMarkerType } from '__generated__/globalTypes';
import { ContentButtons } from 'components/mapV2/MapV2Modal/elements/ContentButtons';
import { ContentHeader } from 'components/mapV2/MapV2Modal/elements/ContentHeader';
import { ContentImages } from 'components/mapV2/MapV2Modal/elements/ContentImages';
import { ContentText } from 'components/mapV2/MapV2Modal/elements/ContentText';
import { DetailQuery_moment } from 'graphql/query/__generated__/DetailQuery';
import { WorldMapMarkerStory_worldMapView_markers } from 'graphql/query/__generated__/WorldMapMarkerStory';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    story: DetailQuery_moment;
    marker: WorldMapMarkerStory_worldMapView_markers | null;
}

export const MapV2ModalDetailContent = (props: Props): JSX.Element => {
    const story = props.story;

    if (!story) {
        return null;
    }

    const showGoogleMapCoordinates =
        props.marker?.type === EWorldMapMarkerType.V2_ICON ||
        props.marker?.type === EWorldMapMarkerType.V2_VARIANT_ICON;

    return (
        <S_MapV2ModalDetailContent className={props.className}>
            <ContentHeader
                title={story.header?.title}
                imageUrl={story.header?.imageUrl}
                googleMapCoordinates={
                    props.marker && showGoogleMapCoordinates
                        ? {
                              lat: props.marker.lat,
                              lng: props.marker.lng
                          }
                        : null
                }
                imageStyleId={story.header?.imageStyleId}
            />
            {story.header?.text && <ContentText text={story.header.text} />}
            {story.cards.map((card) => {
                if (card.__typename === 'TextCard') {
                    return (
                        <ContentText
                            key={card.cardId}
                            title={card.info.title}
                            text={card.info.description}
                        />
                    );
                }
                if (card.__typename === 'ImageCard') {
                    return (
                        <ContentImages
                            key={card.cardId}
                            imageUrls={card.images.map((e) => e.fullImageUrl)}
                        />
                    );
                }
                if (card.__typename === 'LinkCard') {
                    return (
                        <ContentButtons
                            key={card.cardId}
                            buttons={card.links.map((link) => ({
                                id: link.title,
                                label: link.title,
                                icon: {
                                    prefix: 'fas',
                                    iconName: 'arrow-up-right-from-square'
                                },
                                onClick: () => window.open(link.url)
                            }))}
                        />
                    );
                }
                return null;
            })}

            {/* <ContentPins
                labels={[
                    'Keynote speeches',
                    'Panel discussions',
                    'Pitches',
                    'Hands-on',
                    'Expert panels'
                ]}
            /> */}
        </S_MapV2ModalDetailContent>
    );
};

const S_MapV2ModalDetailContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding-bottom: 100px;
    border-radius: 10px 10px 0 0;
`;
